const loadProfileError = {
	title: 'Unable to Load Profile',
	buttonLabel: 'Try Again',
	buttonAction: 'reload',
};

export const ERROR_DETAILS = {
	AUTHENTICATION: {
		code: '000',
		...loadProfileError,
	},
	GET_PROFILE: {
		code: '001',
		...loadProfileError,
	},
	GET_PROFILE_SELECTOR: {
		code: '002',
		...loadProfileError,
	},
	GET_ALL_PREFERENCES: {
		code: '003',
		...loadProfileError,
	},
	GET_OWNERS_BY_ENTITY: {
		code: '004',
		...loadProfileError,
	},
	SAVE_CONTACT_DISCLAIMER: {
		code: '021',
		message:
			'Unable to Save Your Licensing Information. Please try again in a few minutes.',
	},
	SAVE_COMPLIANCE_LOGO: {
		code: '022',
		message:
			'Unable to Save Your Compliance Logo Information. Please try again in a few minutes.',
	},
	GET_ANALYTICS_URL: {
		code: '032',
		message:
			'Unable to Get Your Social Analytics. Please try again in a few minutes.',
	},
	SAVE_OWNER: {
		code: '041',
		message:
			'Some of Your Profile Information Was Not Updated. Please try again in a few minutes.',
	},
	SAVE_USER: {
		code: '061',
		message:
			'Unable to Save Your User Profile Information. Please try again in a few minutes.',
	},
	SAVE_USER_FAMB: {
		code: '063',
		message:
			'Your profile information was saved but your Mortgage Matchup information was not updated. Please try again in a few minutes.',
	},
	SAVE_DUPLICATE_STATE: {
		code: '',
		message:
			'Only one address per state allowed. Please update your addresses.',
		title: 'Unable To Save Profile',
	},
	F5_BLOCK: {
		code: '070',
		title: 'Action Failed',
		buttonLabel: 'Try Again',
		buttonAction: 'reload',
	},
	POPUP_BLOCKER: {
		code: '080',
		title: 'Print Error',
	},
	NETWORK_ERROR: {
		code: '110',
		title: 'Network Error',
		buttonLabel: 'Try Again',
		buttonAction: 'reload',
	},
	LOAN_OFFICER_OPTIONS: {
		code: '090',
		title: 'brokerId or brokerNMLS is not set',
		path: '/campaign-editor-home/',
		buttonLabel: 'Return to Brand Builder',
		buttonAction: 'routerPush',
	},
	API_ERROR: {
		code: '100',
		title: 'API Error',
	},
	VIDEO_REVIEW_ERROR: {
		code: '120',
		title: 'Unable to Access Video Reviews',
		message:
			'Unable to access video reviews at this time. Please try again in a few minutes. If this error persists please reach out to your Account Executive.',
	},
	PREFERENCE_CENTER_ALERT_ERROR: {
		message: 'Unable to save your Alert notification changes.',
		buttonLabel: 'Return to Company Profile',
		buttonAction: 'close',
	},
};
